import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import CmsService from 'services/CMS'
import Link from 'components/Link'
import WrapperOptimizer from 'components/WrapperOptimizer'
import ProductBlock from './ProductBlock'
import TagManagerService from 'services/TagManager'
import style from './style.scss' //NOSONAR
import ImageLoad from 'components/ImageLoad'

export const GridTextAndCardSmallOrMedium = (props) => {
    const { data, dateServer } = props
    if (!data?.active) return ''

    const [show, setShow] = useState(false)
    const [isSingle, setIsSingle] = useState(false)

    const url = `/busca?fq=H:${data.collection}`

    useEffect(() => {
        const validateDate = CmsService.validDatesItem(data, dateServer)
        if (validateDate) setShow(validateDate)
    }, [data, dateServer])

    function callbackIsSingle(_isSingle) {
        setIsSingle(data.single || _isSingle)
    }

    function gtmInteraction() {
        TagManagerService.interaction('Ver más', 'Grilla Texto Card S/M', data.title)
    }
    const withImage = data?.texto_image;
    let imageResponsive = {};
    if(withImage){
        imageResponsive = {
            768: data ? data.image_mobile : '',
            1440: data ? data.image_desktop : ''
        }
    }

    if (!show) return ''

    return (
        <div className={`grid-text-and-card-small-or-medium ${!(withImage && isSingle) ? 'grid-text-and-card-small-or-medium-is-single' : ''} ${withImage ? ' with-Image' : ''}`}>
            <div className="grid-text-and-card-small-or-medium-right-block">
                {withImage && <div className="grid-card-small-or-medium-image"><ImageLoad srcSet={imageResponsive} src={data.image_desktop} /></div>}
                {!withImage && <div className="grid-text-and-card-small-or-medium-title-wrapper">
                    <h2 className="grid-text-and-card-small-or-medium-title">{data.title}</h2>
                    <Link className="grid-text-and-card-small-or-medium-link" to={url} onClick={gtmInteraction}>
                        Ver más
                    </Link>
                </div>}

                {!withImage && <div className="grid-text-and-card-small-or-medium-paragraph">{data.paragraph}</div>}
            </div>
            <div className={`grid-text-and-card-small-or-medium-left-block ${isSingle ? 'grid-text-and-card-small-or-medium-left-block-is-single': ''}`}>
                <WrapperOptimizer typeComponent="home_sliders_products">
                    {(_data) => {
                        if (!_data) return ''
                        return (
                            <ProductBlock
                                options={{ collectionId: data.collection, data }}
                                single={isSingle}
                                campaignData={_data}
                                callbackIsSingle={callbackIsSingle}
                            />
                        )
                    }}
                </WrapperOptimizer>
            </div>
        </div>
    )
}

GridTextAndCardSmallOrMedium.propTypes = {
    data: PropTypes.shape({
        acf_fc_layout: PropTypes.string,
        active: PropTypes.bool,
        start_date: PropTypes.string,
        end_date: PropTypes.string,
        title: PropTypes.string,
        paragraph: PropTypes.string,
        collection: PropTypes.string,
        single: PropTypes.bool,
    }),
    dateServer: PropTypes.number,
}

export default GridTextAndCardSmallOrMedium
